import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';

import { TextWarningButton } from '@components/library/button';

interface RemoveValuesButtonProps {
  isVisible: boolean;
  onClick: () => void;
  isSingular?: boolean;
  /** Field name for unique accessible label (e.g. "Packaging Design") */
  fieldName?: string;
}

export const RemoveValuesButton: FunctionComponent<RemoveValuesButtonProps> = ({
  isSingular = false,
  isVisible,
  onClick,
  fieldName
}) => {
  const ariaLabel = fieldName
    ? (isSingular ? t`Remove value from ${fieldName}` : t`Remove values from ${fieldName}`)
    : undefined;

  return (
    <>
      {isVisible && (
        <TextWarningButton
          aria-label={ariaLabel}
          className="custom-field-values--remove"
          icon="bff-remove"
          onClick={onClick}
        >
          {isSingular ? <Trans>Remove value</Trans> : <Trans>Remove values</Trans>}
        </TextWarningButton>
      )}
    </>
  );
};
